<div class="row">
  <h2 aria-controls="shareCapital">
    Capital-actions de la société cessionnaire
  </h2>
  <table class="table table-light">
    <thead>
      <tr>
        <th scope="col">Actionnaire</th>
        <th scope="col">Nombre d'actions</th>
        <th scope="col">Catégorie d'actions</th>
        <th scope="col">Prix de base rajusté</th>
        <th scope="col">Capital versé fiscal</th>
        <th scope="col">Juste valeur marchande</th>
      </tr>
    </thead>
    @for (commonSharesClass of results.commonSharesClasses; track commonSharesClass; let i = $index) {
      <tbody>
        @for (shareHolder of commonSharesClass.shareholders; track shareHolder; let i = $index) {
          <tr>
            <td>{{ shareHolder.title }}</td>
            <td>{{ shareHolder.numberOfShares }}</td>
            <td>{{ commonSharesClass.title }}</td>
            <td>{{ shareHolder.adjustedCostBase | currencyCents | notAvailable }}</td>
            <td>{{ shareHolder.totalPaidUpCapital | currencyCents | notAvailable }}</td>
            <td>{{ shareHolder.fairMarketValue | currencyCents | notAvailable }}</td>
          </tr>
        }
      </tbody>
    }
    @for (preferredSharesClass of results.preferredSharesClasses; track preferredSharesClass; let i = $index) {
      <tbody>
        @for (shareHolder of preferredSharesClass.shareholders; track shareHolder; let i = $index) {
          <tr>
            <td>{{ shareHolder.title }}</td>
            <td>{{ shareHolder.numberOfShares }}</td>
            <td>{{ preferredSharesClass.title }}</td>
            <td>{{ shareHolder.adjustedCostBase | currencyCents | notAvailable }}</td>
            <td>{{ shareHolder.totalPaidUpCapital | currencyCents | notAvailable }}</td>
            <td>{{ shareHolder.fairMarketValue | currencyCents | notAvailable }}</td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>